import React from "react";
import { Container } from 'react-bootstrap';

import WOW from "wowjs";

class Hero extends React.Component {

	componentDidMount() {
    	new WOW.WOW().init();
  	}
  	render() {
		return (
			<div className="HereoBanner automotive-back">
			    <div className="Banner_Content">
					<Container fluid>
						<h2 className="pagehead-title wow fadeInUp">RETAIL & ECOMMERCE</h2>
						<div className="red-border"> </div>
						<p>Making tomorrow's retail industry more effective, efficient and affordable by building IT solutions that positively impacts the business of retailers.</p>
					</Container>
				</div>
			</div>
		);
	}
};

export default Hero;
